import Loader from "components/Loader";
import { useState, useEffect } from "react";
import { Button } from "../Button";
import RadioButton from "../RadioButton";
import ShoppingCartService from "../services/shopping-cart.service";
import TextBox from "../TextBox";
import { useErrorBoundary } from "basket/ErrorBoundary";
import { SupplyOwnFabric } from "../SupplyOwnFabric";
import ProductQtyInput from "components/ProductQtyInput";
import { OtherFabricSelector } from "../OtherFabricSelector";
import InformationOverlay from "../InformationOverlay";
import useInfoIcons from "hooks/useInfoIcons";
import UnitConverter from "components/UnitConverter";
import NumberInput from "../NumberInput";
import Checkbox from "../Checkbox";
import { formatCurrency} from 'utils/utils';

export function BasketEditRomanBlindsItem(props) {
    const { item, updateFabricItem, close } = props;
    const handleError = useErrorBoundary();
    const [price, setPrice] = useState(item.price);
    const [metres, setMetres] = useState(item.fabric.fabricMetres.toFixed(1) + 'm');
    const [formData, setFormData] = useState({
        quantity: item.quantity,
        width: item.fabric.width,
        height: item.fabric.height,
        installationHeight: item.fabric.installationHeight,
        isStacked: item.fabric.isStacked,
        customization: item.fabric.customization,
        location: item.fabric.location,
        sessionId: item.productId,
        isRecessed: item.fabric.isRecessed,
        liningColour: item.fabric.liningColour,
        isInterlined: item.fabric.isInterlined,
        isHandsewn: item.fabric.isHandSewn,
        isMotorised: item.fabric.isMotorised,
        chainPosition: item.fabric.chainPosition,
        liningId: item.fabric.liningId,
        chainColourId: item.fabric.chainColourId,
        motorisationComponentId: item.fabric.motorisationComponentId,
        fabricId: item.fabricId,
        supplyOwnFabricNameOrDescription: item.supplyOwnFabricNameOrDescription,
        FabricRollWidth: item.supplyOwnFabricRollWidth,
        VerticalPatternRepeat: item.supplyOwnFabricPatternRepeat
    });

    const [measurementsChecked, setMeasurementsChecked] = useState(false)
    const [showMeasurementsCheckError, setShowMeasurementsCheckError] = useState(false)

    const [isSubmitDisabled, setSubmitDisabled] = useState(false);
    const [liningBlockVisible, setLiningBlockVisible] = useState(formData.liningId !== 7)
    const [isLoading, setLoading] = useState(false)
    const [showFireRetardantLinings, setShowFireRetardantLinings] = useState(false)
    const [showMotorisationComponents, setShowMotorisationComponents] = useState(formData.isMotorised)
    const [errors, setErrors] = useState({});

    const [linings, setLinings] = useState([])
    const [fireRetanrdantLinings, setFireRetanrdantLinings] = useState([])
    const [chainColours, setChainColours] = useState([])
    const [motorisationComponents, setMotorisationComponents] = useState([])
    
    const [fabrics, setFabrics] = useState([])
    const [totalFabricsCount, setTotalFabricsCount] = useState(0)
    const [selectedFabric, setSelectedFabric] = useState(formData.fabricId)

    const [itemTitle, setItemTitle] = useState(`${item.fabric.fabricName} in ${item.colour || ''} Fabric by ${item.fabric.supplier.name || ''}`);;
    const title = () => item.supplyOwnFabric ? 'Edit Roman Blinds in Supply Your Own Fabric' : `Edit Roman Blinds - ${itemTitle}`;
        
    const infoIcons = useInfoIcons(item.productType);

    const handleInputChange = (field, value) => {
        if (field === 'isMotorised') { setShowMotorisationComponents(!showMotorisationComponents) }
        if (field === 'liningId') { setLiningBlockVisible(value !== 7) }
        if (field === 'isInterlined') { 
            setFormData((prev) => ({
                ...prev,
                isInterlined: value,
                isHandsewn: value || prev.isHandsewn,
            }))

            return;
        }

        setFormData((prevData) => {
            return {
                ...prevData,
                [field]: value,
            }
        });
    };

    const handleInputChangeUniversal = (e) => {        
        const { name, value } = e.target;
        const updatedData = { ...formData, [name]: value };
        setFormData(updatedData);
    };
    
    const handleQuantityChange = (value) => handleInputChange('quantity', value);

    const createItem = () => {
        return {
            ...item,
            fabricId: selectedFabric,
            fabric: {
                fabricId: selectedFabric,
                width: formData.width,
                height: formData.height,
                location: formData.location,
                customization: formData.customization,
                quantity: formData.quantity,
                isRecessed: formData.isRecessed,
                installationHeight: formData.installationHeight,
                isStacked: formData.isStacked,
                liningColour: formData.liningColour,
                isInterlined: formData.isInterlined,
                isHandSewn: formData.isHandsewn,
                isMotorised: formData.isMotorised,
                chainPosition: formData.chainPosition,
                liningId: formData.liningId,
                chainColourId: formData.chainColourId,
                motorisationComponentId: formData.motorisationComponentId
            },
            supplyOwnFabricNameOrDescription: formData.supplyOwnFabricNameOrDescription,
            supplyOwnFabricPatternRepeat: formData.VerticalPatternRepeat,
            supplyOwnFabricRollWidth: formData.FabricRollWidth
        }
    }

    const handlerMeasurementCheck = () => {
        setMeasurementsChecked(!measurementsChecked)
        setShowMeasurementsCheckError(false)
    }

    const handleUpdate = async () => {
        if (!measurementsChecked) {
            setShowMeasurementsCheckError(true)
            return
        }

        if (!formData.installationHeight && !formData.isMotorised) {
            setErrors(prev => ({
                ...prev,
                InstallationHeight: 'The installation height must be greater than the Length of the roman blind'
            }));
            return;
        }

        setLoading(true);
        setSubmitDisabled(true);

        await updateFabricItem(createItem());

        setSubmitDisabled(false);
        setLoading(false);
    }

    const updatePrice = async () => {
        const item = createItem()
        
        setErrors([])
        
        if (item.supplyOwnFabric) {
            const isValidResponse = await fetch('/api/product/supply-own-fabric/validate', {
                method: 'post',
                headers: {
                    'Content-Type': 'application/json; charset=utf-8'
                },
                body: JSON.stringify({
                    Description: item.supplyOwnFabricNameOrDescription,
                    VerticalPatternRepeat: Number(item.supplyOwnFabricPatternRepeat),
                    FabricRollWidth: Number(item.supplyOwnFabricRollWidth)
                })
            })
            
            if (isValidResponse.status !== 200) {
                const json = await isValidResponse.json();
                
                const lowercasedErrors = Object.entries(json).reduce((acc, [key, value]) => {
                    acc[key] = value;
                    return acc;
                }, {});

                setErrors(prev => ({
                    ...prev,
                    ...lowercasedErrors
                }));
            }
        }

        const result = await ShoppingCartService.create('price', createItem())
            .catch(_ => { handleError('Could not load item price. Please contact administrator'); });
        setPrice(result.price);
        setMetres(result.fabricMetres.toFixed(1) + 'm');
        setFormData((prev) => ({
            ...prev,
            isHandsewn: result.handSewn
        }))
    }

    const fetchLinings = async () => {
        const response = await ShoppingCartService.get('linings?liningFor=2&liningType=1')
            .catch(_ => { handleError('Could not load item details. Please contact administrator'); });
        if (response) setLinings(response)
    }

    const fetchFireRetardantLinings = async () => {
        const response = await ShoppingCartService.get('linings?liningFor=2&liningType=3')
            .catch(_ => { handleError('Could not load item details. Please contact administrator'); });
        if (response) setFireRetanrdantLinings(response)
    }

    const fetchChainColours = async () => {
        const response = await ShoppingCartService.get('chain-colours')
            .catch(_ => { handleError('Could not load item details. Please contact administrator'); });
        if (response) setChainColours(response)
    }

    const fetchMotorisationComponents = async () => {
        const response = await ShoppingCartService.get('motorised-components')
            .catch(_ => { handleError('Could not load item details. Please contact administrator'); });
        if (response) setMotorisationComponents(response)
    }

    const loadFabrics = async () => {
        setLoading(true)
        const response = await ShoppingCartService.get('same-fabrics?fabricId=' + formData.fabricId)
        setFabrics(response.fabrics)
        setTotalFabricsCount(response.totalCount)
        setLoading(false)
    }

    const loadAllFabrics = async () => {
        setLoading(true)
        const response = await ShoppingCartService.get('same-fabrics?fabricId=' + formData.fabricId + '&showAll=true')
        setFabrics(response.fabrics)
        setTotalFabricsCount(response.totalCount)
        setLoading(false)
    }

    const validatePrice = async (item, callback) => {
        fetch('/api/product/roman-blinds/validate', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify(item)
        })
        .then(response => {
            setErrors([]) // clear errors
            if (!response.ok) {
                return response.json().then(err => { throw err });
            }
            return response.json();
        })
        .then(() => {
            callback(item);
        })
        .catch(jsonResponse => {
            const lowercasedErrors = Object.entries(jsonResponse).reduce((acc, [key, value]) => {
                acc[key] = value;
                return acc;
            }, {});

            setErrors(prevErrors => ({
                ...prevErrors,
                ...lowercasedErrors
            }));
        });
    }

    useEffect(() => {
        const foundFabric = fabrics.find(fabric => fabric.fabricId === selectedFabric);
        if (foundFabric){                    
            setItemTitle(foundFabric.fullName);
            validatePrice(formData, updatePrice)
        }
    }, [selectedFabric]);

    useEffect(() => {
        fetchLinings()
        fetchFireRetardantLinings()
        fetchChainColours() 
        fetchMotorisationComponents()
        loadFabrics()
    }, [])

    useEffect(() => {
        validatePrice(formData, updatePrice)
    }, [formData.isStacked,
        formData.isRecessed,
        formData.liningColour,
        formData.isInterlined,
        formData.isHandsewn,
        formData.isMotorised,
        formData.chainPosition,
        formData.liningId,
        formData.chainColourId,
        formData.motorisationComponentId,
        formData.fabricId,
        formData.quantity,
    ])

    useEffect(() => setSubmitDisabled(Object.keys(errors).length > 0), [errors])

    useEffect(() => {
        setShowFireRetardantLinings(
            fireRetanrdantLinings.some(lining => lining.id === formData.liningId)
        );
    }, [fireRetanrdantLinings])

    return (
        <Loader isLoading={isLoading}>
            <form className="p-32 pb-54 bg3 measurements-change active-group sm-p-20">
                <div className="row">
                    <div className="col">
                        <div className="subtitle1 mb-16 sm-text-24 default-text">{title() + ' '}
                            {infoIcons && infoIcons.length > 0  && (
                                <span className="paragraph-info-icon-wrapper">                                        
                                    <InformationOverlay item={infoIcons.find(o => o.name === "Description")} />
                                </span>
                            )}
                        </div>
                    </div>
                    <div className="col-auto ps-24">
                        <span
                            className="curtains-icon curtains-icon-close size-24 show-btn hide-btn"
                            onClick={() => close()}></span>
                    </div>
                </div>

                { item.supplyOwnFabric && <SupplyOwnFabric fabricData={formData} errors={errors} handleInputChange={handleInputChangeUniversal} onBlur={() => validatePrice(formData, updatePrice)} /> }
                { !item.supplyOwnFabric && <OtherFabricSelector fabrics={fabrics} totalFabricsCount={totalFabricsCount} loadAllFabrics={loadAllFabrics} selectedFabric={selectedFabric} setSelectedFabric={setSelectedFabric} /> }

                <div>
                    <div className='row'>
                        <div className="col">
                            <div className="body-text3 gray mb-8">Measurements:</div>
                        </div>
                        <div className='col-auto'>
                            {infoIcons && infoIcons.length > 0  && (
                                <InformationOverlay item={infoIcons.find(o => o.name === "HowToMeasure")} clickTitle="How to Measure?" />
                            )}
                        </div>                            
                    </div>
                </div>

                <div className="row d-flex gap-40 mb-16">
                    <div className="col">
                        <div className="body-text3 mb-8">Width</div>
                        <NumberInput
                            name="width"
                            value={formData.width}
                            onChange={(e) => handleInputChange('width', e.target.value)}
                            decimals={1}
                            onBlur={() => validatePrice(formData, updatePrice)}
                        />
                        {errors.Width && (
                            <span className="field-validation-error">{errors.Width}</span>
                        )}
                    </div>
                    <div className="col">
                        <div className="body-text3 mb-8">Height</div>
                        <NumberInput
                            name="height"
                            value={formData.height}
                            onChange={(e) => handleInputChange('height', e.target.value)}
                            decimals={1}
                            onBlur={() => validatePrice(formData, updatePrice)}
                        />
                        {errors.Height && (
                            <span className="field-validation-error">{errors.Height}</span>
                        )}
                    </div>
                </div>

                <UnitConverter />

                <hr className="secondary-line mb-16"></hr>

                <div>
                    <div className="body-text3 gray mt-16 mb-8 align-center gap_3">Width Measurement:
                        {infoIcons && infoIcons.length > 0  && (
                            <InformationOverlay item={infoIcons.find(o => o.name === "Recessed")} />
                        )}
                    </div>
                    <div className="d-flex gap-32 mb-16 have-first-el-checked">
                        <RadioButton
                            name="recessed"
                            label={'Actual'}
                            value={false}
                            checked={!formData.isRecessed}
                            onChange={() => handleInputChange('isRecessed', false)}
                        />
                        <RadioButton
                            name="recessed"
                            label={'Recessed'}
                            value={true}
                            checked={formData.isRecessed}
                            onChange={() => handleInputChange('isRecessed', true)}
                        />
                    </div>
                    <div className="dashed-line"></div>
                </div>

                <div>
                    <div className="body-text3 gray mt-16 mb-8 align-center gap_3">Cascaded Or Stacked:
                        {infoIcons && infoIcons.length > 0  && (
                            <InformationOverlay item={infoIcons.find(o => o.name === "CascadedOrStacked")} />
                        )}
                    </div>
                    <div className="d-flex gap-32 mb-16 have-first-el-checked">
                        <RadioButton
                            name="stacked"
                            label={'Cascaded'}
                            value={false}
                            checked={!formData.isStacked}
                            onChange={() => handleInputChange('isStacked', false)}
                        />
                        <RadioButton
                            name="stacked"
                            label={'Stacked'}
                            value={true}
                            checked={formData.isStacked}
                            onChange={() => handleInputChange('isStacked', true)}
                        />
                    </div>
                    <div className="dashed-line"></div>
                </div>

                <div>
                    <div className="body-text3 gray mt-16 mb-8 align-center gap_3">Linings:
                        {infoIcons && infoIcons.length > 0  && (
                            <InformationOverlay item={infoIcons.find(o => o.name === "Lining")} />
                        )}
                    </div>
                    <div className="d-flex gap-32 row-gap-16 nowrap-labels mb-16 have-first-el-checked" style={{ flexWrap: 'wrap' }}>
                        {
                            linings.map((lining) => (
                                <RadioButton
                                    name="lining"
                                    label={lining.name}
                                    value={lining.id}
                                    checked={formData.liningId === lining.id}
                                    onChange={() => handleInputChange('liningId', lining.id)}
                                    key={lining.id}
                                />
                            ))
                        }
                    </div>
                    {
                        showFireRetardantLinings ?
                            <label className="body-text6 pointer" onClick={() => setShowFireRetardantLinings(!showFireRetardantLinings)}>- Click here for hide Fire Retardant Lining options</label> :
                            <label className="body-text6 pointer" onClick={() => setShowFireRetardantLinings(!showFireRetardantLinings)}>+ Click here for show Fire Retardant Lining options</label>
                    }
                    {
                        showFireRetardantLinings &&
                        <div>

                            <div className="body-text3 gray mt-16 mb-8 align-center gap_3">Fire Retardant Linings:</div>
                            <div className="d-flex gap-32 have-first-el-checked" style={{ flexWrap: 'wrap' }}>
                                {
                                    fireRetanrdantLinings.map((lining) => (
                                        <RadioButton
                                            name="lining"
                                            label={lining.name}
                                            value={lining.id}
                                            checked={formData.liningId === lining.id}
                                            onChange={() => handleInputChange('liningId', lining.id)}
                                            key={lining.id}
                                        />
                                    ))
                                }
                            </div>
                        </div>
                    }
                    <div className="dashed-line mt-16"></div>
                </div>

                <div className={liningBlockVisible ? '' : 'd-none'}>
                    <div className="body-text3 gray mt-16 mb-8 align-center gap_3">Lining Colour:
                        {infoIcons && infoIcons.length > 0  && (
                            <InformationOverlay item={infoIcons.find(o => o.name === "LiningColour")} />
                        )}
                    </div>
                    <div className="d-flex gap-32 mb-16 have-first-el-checked">
                        <RadioButton
                            name="liningColour"
                            label={'Ivory'}
                            value={false}
                            checked={!formData.liningColour}
                            onChange={() => handleInputChange('liningColour', false)}
                        />
                        <RadioButton
                            name="liningColour"
                            label={'White'}
                            value={true}
                            checked={formData.liningColour}
                            onChange={() => handleInputChange('liningColour', true)}
                        />
                    </div>
                    <div className="dashed-line"></div>
                </div>

                <div className={liningBlockVisible ? '' : 'd-none'}>
                    <div className="body-text3 gray mt-16 mb-8 align-center gap_3">Interlining:
                        {infoIcons && infoIcons.length > 0  && (
                            <InformationOverlay item={infoIcons.find(o => o.name === "Interlining")} />
                        )}
                    </div>
                    <div className="d-flex gap-32 mb-16 have-first-el-checked">
                        <RadioButton
                            name="interlined"
                            label={'Yes'}
                            value={1}
                            checked={formData.isInterlined}
                            onChange={() => handleInputChange('isInterlined', true)}
                        />
                        <RadioButton
                            name="interlined"
                            label={'No'}
                            value={0}
                            checked={!formData.isInterlined}
                            onChange={() => handleInputChange('isInterlined', false)}
                        />
                    </div>
                    <div className="dashed-line"></div>
                </div>

                <div>
                    <div className="body-text3 gray mt-16 mb-8 align-center gap_3">Handsewn:
                        {infoIcons && infoIcons.length > 0  && (
                            <InformationOverlay item={infoIcons.find(o => o.name === "HandSewn")} />
                        )}
                    </div>
                    <div className="d-flex gap-32 mb-16 have-first-el-checked">
                        <RadioButton
                            disabled={formData.isInterlined}
                            name="handsewn"
                            label={'Yes'}
                            value={true}
                            checked={formData.isHandsewn}
                            onChange={() => handleInputChange('isHandsewn', true)}
                        />
                        <RadioButton
                            disabled={formData.isInterlined}
                            name="handsewn"
                            label={'No'}
                            value={false}
                            checked={!formData.isHandsewn}
                            onChange={() => handleInputChange('isHandsewn', false)}
                        />
                    </div>
                    <div className="dashed-line"></div>
                </div>
                
                {
                    !showMotorisationComponents &&
                    <>
                        <div>
                            <div className="body-text3 gray mt-16 mb-8 align-center gap_3">Chain Colour:
                                {infoIcons && infoIcons.length > 0  && (
                                    <InformationOverlay item={infoIcons.find(o => o.name === "ChainColour")} />
                                )}
                            </div>
                            <div className="d-flex gap-32 row-gap-16 nowrap-labels mb-16 have-first-el-checked" style={{ flexWrap: 'wrap' }}>
                                {
                                    chainColours.map((colour) => (
                                        <RadioButton
                                            name="chain-colour"
                                            label={colour.name}
                                            value={colour.id}
                                            checked={formData.chainColourId === colour.id}
                                            onChange={() => handleInputChange('chainColourId', colour.id)}
                                            key={colour.id}
                                        />
                                    ))
                                }
                            </div>
                            <div className="dashed-line"></div>
                        </div>

                        <div>
                            <div className="body-text3 gray mt-16 mb-8 align-center gap_3">Chain position:
                                {infoIcons && infoIcons.length > 0  && (
                                    <InformationOverlay item={infoIcons.find(o => o.name === "ChainPosition")} />
                                )}
                            </div>
                            <div className="d-flex gap-32 mb-16 have-first-el-checked">
                                <RadioButton
                                    name="chain-position"
                                    label={'Left'}
                                    value={1}
                                    checked={formData.chainPosition === 1}
                                    onChange={() => handleInputChange('chainPosition', 1)}
                                />
                                <RadioButton
                                    name="chain-position"
                                    label={'Right'}
                                    value={0}
                                    checked={formData.chainPosition === 0}
                                    onChange={() => handleInputChange('chainPosition', 0)}
                                />
                            </div>
                            <div className="dashed-line"></div>
                        </div>
                    </>
        }

                <div>
                    <div className="body-text3 gray mt-16 mb-8 align-center gap_3">Motorised:
                        {infoIcons && infoIcons.length > 0  && (
                            <InformationOverlay item={infoIcons.find(o => o.name === "Motorised")} />
                        )}
                    </div>
                    <div className="d-flex gap-32 mb-16 have-first-el-checked">
                        <RadioButton
                            name="motorised"
                            label={'Yes'}
                            value={true}
                            checked={formData.isMotorised}
                            onChange={() => handleInputChange('isMotorised', true)}
                        />
                        <RadioButton
                            name="motorised"
                            label={'No'}
                            value={false}
                            checked={!formData.isMotorised}
                            onChange={() => handleInputChange('isMotorised', false)}
                        />
                    </div>
                    <div className="dashed-line"></div>
                </div>
                {
                    showMotorisationComponents &&
                    <div>
                        <div className="body-text3 gray mt-16 mb-8 align-center gap_3">Control Unit:
                            {infoIcons && infoIcons.length > 0  && (
                                <InformationOverlay item={infoIcons.find(o => o.name === "ControlUnit")} />
                            )}
                        </div>
                        <div className="d-flex gap-32 row-gap-16 nowrap-labels mb-16 have-first-el-checked" style={{ flexWrap: 'wrap' }}>
                            {
                                motorisationComponents.map((component) => (
                                    <RadioButton
                                        name="motorisation-component"
                                        label={component.name}
                                        value={component.id}
                                        checked={formData.motorisationComponentId === component.id}
                                        onChange={() => handleInputChange('motorisationComponentId', component.id)}
                                        key={component.id}
                                    />
                                ))
                            }
                        </div>
                        <div className="dashed-line"></div>
                    </div>
                }

                {/* Installation Height */}
                
                {
                    formData.isMotorised == false && 
                        <div className="row d-flex gap-40 sm-gap-16">
                            <div className="col col-5">
                                <div className="body-text3 gray mt-16 mb-8 align-center gap_3">Installation Height:
                                    {infoIcons && infoIcons.length > 0  && (
                                        <InformationOverlay item={infoIcons.find(o => o.name === "InstallationHeight")} />
                                    )}
                                </div>
                                <NumberInput
                                    name="installationHeight"
                                    value={formData.installationHeight}
                                    onChange={(e) => handleInputChange('installationHeight', e.target.value)}
                                    decimals={0}
                                    onBlur={() => validatePrice(formData, updatePrice)}
                                />
                                {errors.InstallationHeight ? (
                                    <span className="field-validation-error">{errors.InstallationHeight}</span>
                                ) : null}
                            </div>
                        </div>
                }

                <div>
                    <div className="body-text3 gray mt-16 mb-16 align-center gap_3">Roman Blind Customisation:</div>
                    <div className="max-width-410 mb-16 sm-text-14">If you have special requests, write below or <a href="/contact-us" className="underline">contact us</a> <a href="tel:0345 8620743" className="underline">0345 8620743</a>.</div>
                    <div className="mb-16">
                        <TextBox
                            name="Customization"
                            value={formData.customization}
                            placeholder="e.g. Trim or borders"
                            onChange={(e) => handleInputChange('customization', e.target.value)}
                            onBlur={() => validatePrice(formData, updatePrice)}
                        />
                    </div>
                    {errors.Customization && (
                        <span className="field-validation-error">{errors.Customization}</span>
                    )}
                </div>
                <div className="dashed-line"></div>

                <div style={{marginBottom: '16px'}}>
                    <div className="body-text3 gray mt-16 mb-16 align-center gap_3">Roman Blind Location:</div>
                    <div className="max-width-410 mb-16 sm-text-14">Let us know where your roman blind will be used, and we will include this in your order details.</div>
                    <div className="mb-16">
                        <TextBox
                            name="Location"
                            value={formData.location}
                            placeholder="e.g. Living room front window"
                            onChange={(e) => handleInputChange('location', e.target.value)}
                            onBlur={() => validatePrice(formData, updatePrice)}
                        />
                    </div>
                    {errors.Location && (
                        <span className="field-validation-error">{errors.Location}</span>
                    )}
                </div>

                {
                    item.supplyOwnFabric && 
                        <div>
                            <div className="body-text3 gray mt-32 mb-8 align-center gap_3">Quantity of fabric per item to be supplied by you:</div>
                            <TextBox name='sof-fabric-length' value={metres} className='max-width-150 mb-16' />
                        </div>
                }

                <Checkbox 
                    checked={measurementsChecked} 
                    label={'I have checked all measurements'}
                    value={!measurementsChecked}
                    onChange={handlerMeasurementCheck}
                    requiredMessage={''}
                    name={'measurementsChecked'} />
                { showMeasurementsCheckError && <div className="text-danger m-8">Please confirm you have checked everything.</div> }

                <hr className="secondary-line mb-16"></hr>

                <div>
                    <div className="subtitle2 mb-8 mt-16">TOTAL: <span className="body-text1">{formatCurrency(price)}</span></div>
                    <div className="body-text6">Delivery for made-to-measure roman blinds: {item.deliveryContent} weeks.</div>
                </div>

                <div className="mb-16 mt-32" id="updateProductQuantity">
                    <div className="dashed-line mb-24"></div>
                    <div className="body-text3 gray mb-16">Quantity:</div>
                    
                    <ProductQtyInput 
                        digits={0}
                        initValue={formData.quantity} 
                        onlyInt={true} 
                        onChange={handleQuantityChange} 
                        onBlur={() => validatePrice(formData, updatePrice)}
                    />
                    {errors.Quantity && (
                        <span className="field-validation-error">{errors.Quantity}</span>
                    )}
                </div>

                <div className="d-flex gap-16 mb-16 sm-column md-column sm-gap-8 sm-mb-0">
                    <div className="w-100 show-btn hide-btn">
                        <Button name="UPDATE" onClick={() => handleUpdate()} disabled={isSubmitDisabled || Object.keys(errors).length > 0} />
                    </div>
                </div>
            </form>
        </Loader>
    );
}